import { render, staticRenderFns } from "./IconBriefcase.vue?vue&type=template&id=4dfe1532&"
import script from "./IconBriefcase.vue?vue&type=script&lang=js&"
export * from "./IconBriefcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports